import axios from 'axios';

const DEFAULT_TIMEOUT_MS = 15000;

let onUnauthorized = null;
let memoryAccessToken = '';

export function setApiAuthHandlers({ onUnauthorized: handler } = {}) {
  onUnauthorized = handler || null;
}

export function setAccessToken(token) {
  memoryAccessToken = token || '';
}

export function getAccessToken() {
  return memoryAccessToken;
}

/**
 * The caller's own history on one channel. Whose history is the server's
 * decision (the JWT), so the only parameters are the channel.
 */
export async function fetchMessageHistory({ channelAddress, channelId }) {
  const response = await webchatApi.get('/messages/', {
    params: {
      channel_address: channelAddress,
      channel_id: channelId,
    },
  });
  return Array.isArray(response.data) ? response.data : [];
}

/** CRA env sometimes uses http(s):// for WS; browsers need ws(s)://. */
export function toWebSocketUrl(url) {
  if (!url) return url;
  if (url.startsWith('https://')) return `wss://${url.slice('https://'.length)}`;
  if (url.startsWith('http://')) return `ws://${url.slice('http://'.length)}`;
  return url;
}

export const graspApi = axios.create({
  baseURL: process.env.REACT_APP_API_GRASP_BASE_URL,
  timeout: DEFAULT_TIMEOUT_MS,
});

export const webchatApi = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: DEFAULT_TIMEOUT_MS,
  withCredentials: true,
});

webchatApi.interceptors.request.use((config) => {
  const token = memoryAccessToken;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

webchatApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isAuthBootstrap =
      url.includes('/auth/otp/') ||
      url.includes('/auth/session/') ||
      url.includes('/auth/logout/');

    if (status === 401 && !isAuthBootstrap && onUnauthorized) {
      onUnauthorized();
    }

    return Promise.reject(error);
  }
);
